import React, { useState } from "react";
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider
} from "@mui/material";
import MoreVertIcon from "@mui/icons-material/MoreVert";

export interface RowActionItem {
  key: string;
  label: string;
  description?: string;
  icon: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
  /** Stile per azioni distruttive (es. elimina) */
  destructive?: boolean;
  /** Separatore sopra questa voce (es. prima di Elimina) */
  dividerBefore?: boolean;
}

interface DataGridRowActionsMenuProps {
  items: RowActionItem[];
  /** Etichetta accessibile sul pulsante */
  ariaLabel?: string;
}

export function DataGridRowActionsMenu({
  items,
  ariaLabel = "Apri menu azioni"
}: DataGridRowActionsMenuProps) {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  return (
    <>
      <IconButton
        data-tour="row-actions"
        size="small"
        aria-label={ariaLabel}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={(e) => setAnchorEl(e.currentTarget)}
      >
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        slotProps={{ paper: { sx: { minWidth: 220, maxWidth: { xs: "calc(100vw - 32px)", sm: 360 } } } }}
      >
        {items.map((item) => (
          <React.Fragment key={item.key}>
            {item.dividerBefore ? <Divider sx={{ my: 0.5 }} /> : null}
            <MenuItem
              disabled={item.disabled}
              onClick={() => {
                item.onClick();
                setAnchorEl(null);
              }}
              sx={{
                alignItems: "flex-start",
                whiteSpace: "normal",
                ...(item.destructive ? { color: "error.main" } : {})
              }}
            >
              <ListItemIcon
                sx={{
                  color: item.destructive ? "error.main" : "text.secondary",
                  minWidth: 36
                }}
              >
                {item.icon}
              </ListItemIcon>
              <ListItemText
                primary={item.label}
                secondary={item.description}
                primaryTypographyProps={{ fontSize: "0.875rem", fontWeight: 500 }}
                secondaryTypographyProps={{ fontSize: "0.75rem" }}
              />
            </MenuItem>
          </React.Fragment>
        ))}
      </Menu>
    </>
  );
}
